import type { BaseEntity } from "../../UniversalCRMTable/types";
import type { EntityQueryResult } from "../types";

/**
 * Normalizes query result to consistent EntityQueryResult shape
 * Handles both old format (with nodes) and new format (with data.data)
 */
export function normalizeQueryResult<T extends BaseEntity>(
  entitiesQueryRaw: any
): EntityQueryResult<T> {
  const entitiesQuery: EntityQueryResult<T> = {
    data: entitiesQueryRaw.data
      ? // Check if it's old shape (has nodes) or new shape (has data.data)
        "nodes" in entitiesQueryRaw.data
        ? {
            data: entitiesQueryRaw.data.nodes,
            totalCount: entitiesQueryRaw.data.totalCount,
            pageInfo: entitiesQueryRaw.data.pageInfo,
          }
        : entitiesQueryRaw.data
      : undefined,
    isLoading:
      "isLoading" in entitiesQueryRaw ? entitiesQueryRaw.isLoading : entitiesQueryRaw.loading,
    error: entitiesQueryRaw.error || null,
    refetch: entitiesQueryRaw.refetch,
    networkStatus:
      entitiesQueryRaw &&
      typeof entitiesQueryRaw === "object" &&
      "networkStatus" in entitiesQueryRaw &&
      typeof entitiesQueryRaw.networkStatus === "number"
        ? entitiesQueryRaw.networkStatus
        : undefined,
  };

  return entitiesQuery;
}
